<template>
  <v-container>
    <div>
      <v-card-title
        class="titulo text-h4 mb-4"
      >
       <v-icon class="mr-2 align-items-center">fas fa-box</v-icon>{{item.id>-1?'Actualizar Unidad':'Crear Unidad'}}
      </v-card-title>
      <ValidationObserver v-slot="{handleSubmit}">
        <v-form @submit.prevent="handleSubmit(save)">
          <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
            <v-text-field
            label='Nombre'
            prepend-icon="mdi-file-document"
            v-model='item.name'
            outlined
            :error-messages="errors"
            :loading="loading"
            ></v-text-field>
          </ValidationProvider>
            <div class="text-center">
              <v-btn type="submit" color="success" :loading="loading"><v-icon class="mr-2">fas fa-sd-card</v-icon>Guardar</v-btn>
            </div>
        </v-form>
      </ValidationObserver>
    </div>
  </v-container>
</template>
<script>
import {getCenter,createCenter,updateCenter} from '@/api/stocks'
import notifications from '@/utils/notifications'
export default {
  name:'UnitCreateUpdate',
  props:['id'],
  data() {
    return {
      item:'',
      loading:false,
    }
  },
  methods:{
    async save(){
      this.loading=true
      if(this.id>-1){
        await updateCenter(this.id,{
          name:this.item.name,
        })
        .then((res)=>{
          notifications.showSuccess('Centro guardado correctamente')
          this.$emit('close')
          this.$emit('updated')
        })
        .catch(err=>{
          notifications.showError('Error actualizando Centro '+err)
        })
        this.loading=false
      }
      else{
        await createCenter({
          name:this.item.name,
        })
        .then((res)=>{
          notifications.showSuccess('Centro creado correctamente')
          this.$emit('close')
          this.$emit('updated')
        })
        .catch(err=>{
          notifications.showError('Error actualizando Centro '+err)
        })
        this.loading=false
      }
    },
    async get(){
      if(this.id>-1){
        this.loading=true
        await getCenter(this.id)
        .then(res=>{
          this.item=res
        })
        .catch((err)=>{
          notifications.showError('Error cargando centro '+err)
        })
        this.loading=false
      }
      else{
        this.item={
          id:this.id,
          name:'',
        }
      }
    }
  },
  watch:{
    id:{
      handler:'get'
    }
  },
  created(){
    this.get()
  }

}
</script>

<style>

</style>